var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialBoosty28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51 15.874 9.83 4.376h5.102l-1.028 3.565-.03.06-2.71 9.41h2.526a1184.88 1184.88 0 0 0-2.475 6.202c-4.664-.05-5.967-3.39-4.827-7.342l.122-.397Zm4.726 7.75 6.15-8.85H14.78l2.27-5.672c3.89.407 5.724 3.472 4.644 7.18-1.15 3.98-5.815 7.341-10.356 7.341h-.102Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialBoosty28);
export default __webpack_public_path__ + "static/media/social-boosty_28.7ed67c17.svg";
export { ForwardRef as ReactComponent };